<template>
	<VDialogV3
		position="center"
		width="400px"
		title="Создание новой услуги"
		:submit-disabled="!newServiceName ? 'Введите наименование' : null"
		@submit-button:clicked="submit"
	>
		<section>
			<VSuggestionSelect
				v-model="newServiceName"
				layout="vertical"
				clearable
				required
				placeholder="Введите наименование новой услуги"
			/>
		</section>
	</VDialogV3>
</template>

<script lang="ts">
import VDialogV3 from '@/lib/components/VDialogV3/VDialogV3.vue';

export default defineComponent({
	name: 'CreateServiceDialog',

	components: {
		VDialogV3,
	},

	emits: ['service:created'],

	data() {
		return {
			newServiceName: null as string | null,
		};
	},

	methods: {
		submit() {
			if (!this.newServiceName) { return; }

			const name = typeof this.newServiceName === 'string'
				? this.newServiceName
				: (this.newServiceName as any).name;

			this.$emit('service:created', name);
			this.newServiceName = null;

			this.$core.dialogs.CreateServiceDialog.hide()
		},
	},
});
</script>
